module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-card', [_c('el-alert', {
    attrs: {
      "title": "优惠券活动说明",
      "type": "info",
      "description": "默认生成的活动分享码不关联推广店铺，如果要指定推广店铺请点击指定店铺活动码选择下载.",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 5
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "优惠券活动列",
      "clearable": ""
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加活动")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "优惠券活动列",
      "name": "admin"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 160
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "活动名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_time",
      "label": "活动时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "banner",
      "label": "图片"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": _vm.wximageurl + scope.row.banner
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }], null, false, 1599325415)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_barcode",
      "label": "活动分享码(无店铺关系)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": _vm.wximageurl + scope.row.activity_barcode
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          attrs: {
            "src": "/static/img/icon_img.png"
          }
        })])], 1)]
      }
    }], null, false, 2625934461)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.handleEditDistribution(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.downloadQRcode(scope.row)
            }
          }
        }, [_vm._v("指定店铺活动码")]), _vm._v(" "), _c('br')], 1)]
      }
    }], null, false, 2760251450)
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "指定店铺活动码",
      "visible": _vm.distributor_dialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.distributor_dialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "160px"
    },
    model: {
      value: (_vm.distributor_from),
      callback: function($$v) {
        _vm.distributor_from = $$v
      },
      expression: "distributor_from"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.distributor_from.name),
      callback: function($$v) {
        _vm.$set(_vm.distributor_from, "name", $$v)
      },
      expression: "distributor_from.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作用门店"
    }
  }, [_vm._l((_vm.relDistributors), function(item, index) {
    return _c('el-tag', {
      key: item.distributor_id,
      staticClass: "new-tag",
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(index)
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + "\n                    ")])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.addDistributoreAction
    }
  }, [_vm._v("+ 点击搜索店铺 ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer content-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.clickable
    },
    on: {
      "click": _vm.handleDistributionSave
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.DistributorVisible,
      "is-valid": _vm.isValid,
      "rel-data-ids": _vm.relDistributors,
      "get-status": _vm.DistributorStatus
    },
    on: {
      "chooseStore": _vm.DistributorChooseAction,
      "closeStoreDialog": _vm.closeDialogAction
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e2e85a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e2e85a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/couponActivity.vue
// module id = 2650
// module chunks = 0